
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8493_4558)"}},[_c('path',{attrs:{"d":"M8.773 1.26L8.255.743a.478.478 0 00-.57-.08L8.853 1.83a.479.479 0 00-.08-.57zM4.804 4.767c-.01.233-.361.991-.903 1.532L.137 10.063l.001.002a.511.511 0 00.011.71l.472.472c.195.196.51.199.71.01l.002.002 3.764-3.764c.664-.664 1.356-1.787 1.397-2.65.004-.086.055-.245.145-.438L5.39 3.159c-.324.531-.563 1.113-.587 1.608z"}}),_c('path',{attrs:{"d":"M11.975 3.608c-.016-.015-.04-.021-.067-.023L9.186 2.66l-.017.017a.23.23 0 01-.324-.324l.017-.017L7.244.717l-1.9 1.9 1.618 1.619.017-.018a.23.23 0 01.323.324l-.017.017.927 2.722c.001.028.007.052.023.067.17.17 1.145-.53 2.177-1.562 1.033-1.033 1.732-2.008 1.563-2.178z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8493_4558"}},[_c('path',{attrs:{"d":"M0 0h12v12H0z"}})])])])
          )
        }
      }
    